export default __webpack_public_path__ + "static/media/administrator_line_icon.ab03f3b3.svg";